import { createStore } from 'vuex'

import { auth } from './auth'
import { questions } from './questions'
import { groups } from './groups'

export default createStore({
  modules: {
    auth,
    questions,
    groups
  }
})
